<template>

	<div style="width:100%;">

        <div class="questionario-group pt20">
            <label for="nome">Seu nome completo</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': nomeInvalido }"
                id="nome" name="nome"
                v-model="dadosCadastrais.nome" />
			
            <div v-if="nomeInvalido" class="invalid-feedback":class="{ 'd-block': nomeInvalido}">
                <p>O campo nome é obrigatório!</p>
            </div>

        </div>

        <div class="questionario-group  pt20">
            <label for="email">Seu e-mail para contato</label>
            <input type="email" class="form-control" :class="{ 'is-invalid': emailInvalido }"
                id="email" name="email"
                v-model="dadosCadastrais.email" />

            <div v-if="emailInvalido" class="invalid-feedback":class="{ 'd-block': emailInvalido}">
            	<p>Entre com um email válido!</p>
            </div>
        </div>

		<div class="text-right pt20">
			<button class="btn btn-primary" @click="proximo">Próximo</button>
		</div>

	</div>

</template>

<script>

export default {
	name: "DadosCadastrais",
	data() {
        return {
        	dadosCadastrais: {
	            nome: null,
	            email: null,
        	},
        	nomeInvalido: false,
        	emailInvalido: false,
        }
    },
	methods: {
		proximo () {

			if (!this.dadosCadastrais.nome) {
				this.nomeInvalido = true;
			}
			else {
				this.nomeInvalido = false;
			}

			if (!this.dadosCadastrais.email) {
				this.emailInvalido = true;
			} else if (!this.validEmail(this.dadosCadastrais.email)) {
				this.emailInvalido = true;
			}
			else {
				this.emailInvalido = false;
			}

			if (!this.nomeInvalido && !this.emailInvalido) {
				this.$parent.showQuestionarios(this.dadosCadastrais);
			}

		},
		validEmail (email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
    	},
	}
}
</script>

<style scoped>

</style>
